<template>
    <div>
        <v-row class="px-3" v-if="!massImportStatus">
            <v-col cols="12">
                <div class="mx-5 my-3">
                    <h4 class="subtitle-1 font-weight-medium">{{ $t('modules.changeStudyPlan.table.massImportDrawer.title') }}</h4>
                    <a href="/templates/template-changeStudyPlan.xlsx" download>
                    <Button
                        outlined
                        class="mt-4 mb-8"
                        icon="mdi-download"
                        :text="$t('actions.download_template')"
                    ></Button>
                    </a>
                </div>
                <div v-show="!sendButton.loading">
                    <DropFiles
                        :key="dropFilesKey"
                        v-model="file"
                        class="mx-5 mt-5"
                        extension=".xls,.xlsx"
                        limitSizeBytes="2000000"
                        type-file="excel"
                    ></DropFiles>
                </div>
                <div class="bt-6" v-show="sendButton.loading">
                    <h3 class="font-weight-medium text-center mt-6 mb-6 ">{{ $t('modules.changeStudyPlan.table.massImportDrawer.loading') }}</h3>
                </div>
            </v-col>
            <v-col cols="12" class="d-flex justify-end">
            <Button
                white
                class="my-6"
                :text="$t('actions.close')"
                :disabled="sendButton.loading"
                @clicked="closeConfirmation"
            ></Button>
            <Button
                class="mx-5 my-6"
                :loading="sendButton.loading"
                :success="sendButton.success"
                :error="sendButton.error"
                :text="$t('actions.load')"
                :successText="$t('actions.loaded')"
                :errorText="$t('actions.cancel')"
                @end="resetButtonValues"
                @clicked="confirmationPopup"
            ></Button>
            </v-col>
        </v-row>
        <SuccessMessage
            v-else
            :type="successMessage.type"
            :title="successMessage.title"
            :actionPrimary="successMessage.actionPrimary"
            :actionSecondary="successMessage.actionSecondary"
        />
        </div>
    </template>
    
    <script>
    import DropFiles from '@/components/DropFiles/DropFiles';
    import Button from '@/components/Button/Button';
    import SuccessMessage from '@/components/SuccessMessage/SuccessMessage';
    import {$studentCareer} from '../Services';

    export default {
        name: 'MassImportWorkData',
        components: {
            DropFiles,
            Button,
            SuccessMessage,
        },
        data() {
            return {
                massImportStatus: false,
                file: null,
                dropFilesKey: 0,
                sendButton: {
                    loading: false,
                    success: false,
                    error: false
                },
                successMessage: {
                    type: 'success',
                    title: '',
                    actionPrimary: { text: '', callback() {} },
                    actionSecondary: { text: '', callback() {} },
                },
            }
        },
        methods: {
        confirmationPopup() {
            if (!this.file) {
            this.$store.dispatch('commons/openPopUp', {
                title: this.$t('modules.changeStudyPlan.table.massImportDrawer.messages.noFiles'),
                actionPrimary: { text: this.$t('actions.accept'), callback() {} },
                icon: { color: 'warning', name: 'mdi-alert' },
                color: 'primary',
            });
            } else {
            this.$store.dispatch('commons/openPopUp', {
                title: this.$t('modules.changeStudyPlan.table.massImportDrawer.messages.sendConfirmation'),
                content: [{ value: this.file.name }],
                actionPrimary: { text: this.$t('actions.send'), callback: () => this.sendFile() },
                actionSecondary: { text: this.$t('actions.cancel'), callback () { } },
                icon: { color: 'warning', name: 'mdi-alert' },
                color: 'primary',
            });
            }
        },
        async sendFile() {
                try {
                    this.sendButton.loading = true;
                    const formData = new FormData()
                    formData.append('file', this.file);
                    const response = await $studentCareer.formData(formData, 'batch')
                    const data = JSON.parse(await response.text())
                    this.successMessage.type = 'success';
                    this.successMessage.title = this.$t('modules.changeStudyPlan.table.massImportDrawer.messages.success', { quantity: data.errorDetail });
                    this.sendButton.success = true;
                } catch (error) {
                    this.successMessage.type = 'error';
                    if (error.errorCode && error.errorCode === 210) {
                        this.successMessage.title = this.$t('modules.changeStudyPlan.table.massImportDrawer.messages.errorAll');
                    } if(error.errorCode && error.errorCode === 204 ) {
                        this.successMessage.title = this.$t('modules.changeStudyPlan.table.massImportDrawer.messages.errorAny');
                        
                    }
                    this.successMessage.actionPrimary = { text: this.$t('modules.changeStudyPlan.table.massImportDrawer.messages.createAgain'), callback: () => { this.newCreate() } },
                    this.successMessage.actionSecondary = { text: this.$t('actions.close'), callback: () => { this.close() } },
                this.sendButton.error = true;
                throw error
                } finally {
                    this.massImportStatus = true;
                    this.sendButton.loading = false;
                }
        },
        resetButtonValues() {
            this.sendButton.loading = false;
            this.sendButton.success = false;
            this.sendButton.error = false;
        },
        closeConfirmation() {
            if (this.file) {
            this.$store.dispatch('commons/openPopUp', {
                title: this.$t('modules.changeStudyPlan.table.massImportDrawer.messages.pendingFiles'),
                actionPrimary: { text: this.$t('actions.yes'), callback: () => this.close() },
                actionSecondary: { text: this.$t('actions.no'), callback () { } },
                icon: { color: 'warning', name: 'mdi-alert' },
                color: 'primary',
            });
            } else {
                this.close()
            }
        },
        close() {
            this.$emit('close')
            setTimeout(() => {
                this.file = null
                this.dropFilesKey++
                this.massImportStatus = false
                this.resetButtonValues()
            }, 1000)
        },
        newCreate() {
            this.$emit('newCreate')
            setTimeout(() => {
                this.file = null
                this.dropFilesKey++
                this.massImportStatus = false
                this.resetButtonValues()
            }, 625)
        },
        },
    }
    </script>
